import React from "react";
import ResourceAddition from "./ResourceAddition";

const Resources = (props) => {
  let locations = typeof props.data.locations !== "undefined" ? props.data.locations : null;
  return (
    <>
      {props.panel && (
        <>
          <div
            id={"resources-panel-" + props.contingent.id}
            className="inb-c-item-details inb-c-order-reservations row"
          >
            <ResourceAddition
              resources={props.contingent.resources}
              id={props.contingent.id}
              app_user_role={props.data.app_user_role}
              contingent={props.contingent}
              dispatch={props.data.dispatch}
              setFilter={props.data.setFilter}
              filter={props.data.filter}
              setNKey={props.data.setNKey}
              sort={props.data.sort}
              setSort={props.data.setSort}
              _key={props.data._key}
              locations={locations}
            />
          </div>
        </>
      )}
      {!props.panel && (
        <ResourceAddition
          resources={props.contingent.resources}
          id={props.contingent.id}
          app_user_role={props.data.app_user_role}
          contingent={props.contingent}
          dispatch={props.data.dispatch}
          setFilter={props.data.setFilter}
          filter={props.data.filter}
          setNKey={props.data.setNKey}
          sort={props.data.sort}
          setSort={props.data.setSort}
          _key={props.data._key}
          locations={locations}
        />
      )}
    </>
  );
};

export default Resources;
